import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'dashboard_auto.mes_contracts.title',
  },
  subTitle: {
    id: 'auto_details.sub_title',
  },
  title_ajout_contrat: {
    id: 'dashboard_auto.title_ajout_contrat',
  },
  FindMoreAboutContracts: {
    id: 'auto_details.my_contracts_guarantees.find_more_about_contracts',
  },
  MySupportServices: {
    id: 'auto_details.my_contracts_guarantees_tab.my_support_services',
  },
  title_sinistre_empty_state: {
    id: 'dashboard_auto.last_sinister.empty_state_title',
  },
  sinitre_title: {
    id: 'auto_details.suivi_sinistre',
  },
  DownloadFileTitle: {
    id: 'auto_details_page.document_download_title',
  },
  sinistre_journale: {
    id: 'suivi_sinistre.suivi_journal_title',
  },
  faireReclamation: {
    id: 'suivi_sinistre.faire_une_reclamation',
  },
  formule_assistance: {
    id: 'auto_details.formules_assitance_file',
  },
  conditions_generales: {
    id: 'auto_details.conditions_generales_file',
  },
  Actif: {
    id: 'dashboard_auto.mes_contracts.actif',
  },
  Encours: {
    id: 'dashboard_auto.mes_contracts.encours',
  },
  attestion_epargn: {
    id: 'attestion_epargn',
  },
});
